export default "__VITE_ASSET__qtMKf7fA__"